import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';
export default function useUpdateMailStatus() {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.UPDATE_MAIL_STATUS,
        data
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('get-mails');
        if (data.message !== 'Mail marked as read') {
          SuccessToast({ text: data.message });
        }
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
